'use client';
import Link from 'next/link';
import { useTranslation } from '~/app/hooks/useTranslation';
import { buildLocalizedHref } from '~/app/lib/routeUtils';
import styles from './page.module.scss';
export default function VoiceTeaser({ locale }) {
  const { t } = useTranslation();
  return <section className={styles.teaser}><div className={styles.wrap}>
    <div><span className={styles.eyebrow}>{t('voiceAssistant.hero.eyebrow')}</span><h2>{t('voiceAssistant.teaser.title')}</h2><p>{t('voiceAssistant.teaser.text')}</p></div>
    <Link className={styles.button} href={buildLocalizedHref(locale, 'platform/voice-ai')}>{t('voiceAssistant.teaser.link')}</Link>
  </div></section>;
}
